import { ReactNode } from 'react';
import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

interface Props {
  children: ReactNode;
  icon?: Icon;
  link?: boolean;
  small?: boolean;
}

const Item = ({ children, icon, link = false, small = true }: Props) => {
  const className = classnames({
    flex: true,
    'flex-row': true,
    'flex-nowrap': true,
    'items-center': true,
    'w-fit': true,
    'justify-center': true,
    'mr-2': true,
    'only:mr-0': true,
    'last:mr-0': true,
    'text-sm': small,
    'text-card-link-color': link,
    'text-pill-color': !link,
    'pointer-events-none': !link,
  });

  return (
    <div className={className}>
      <div className="flex flex-row justify-center items-center mr-1">
        <IconView icon={icon} size={'lg'} />
      </div>
      <div className="flex justify-center items-center">{children}</div>
    </div>
  );
};

export default Item;
